if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.product = null;
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (!this.validateCartProducts()) return;
          
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.product = response;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            //this.dispatchEvent(new CustomEvent("cart:validate:discount"));
            const cartResponse = await this.validateDiscount();
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              let openCart = true;
              if (!cartResponse.includesPantry && cartResponse.item_count != 6) {
                openCart = false;
              }
              this.cart.renderContents(response, openCart);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            // Trigger event after product successfully added to cart
            const product = this.product;
            this.dispatchEvent(new CustomEvent("product:added", { bubbles: true, detail: { product: product } }));
          });
      }

      validateDiscount() {
        return new Promise((resolve) => {
          const event = new CustomEvent("cart:validate:discount", {
            detail: { respond: resolve },
          });
          document.dispatchEvent(event);
        });
      }

      validateCartProducts() {
        const collections = this.getProductCollections();
        const cartPreventModal = document.querySelector(`[data-modal="prevent-cart"]`);
        if(window.cartFor == ''){  return true; }
        if (window.cartFor == 'pantry') {
          if (collections.indexOf('pantry') == -1) {
            cartPreventModal.querySelector("[data-cart-message]").innerHTML = "This cart can process Pantry items only. If you want to order FireRoad meals, too, please empty your cart and start over from the main FireRoad Meals page. These same items are also offered and will ship with the rest of your meals. <br /><br /><strong>Refresh your browser after emptying your cart.</strong>";
            cartPreventModal.removeAttribute("hidden");
            document.body.classList.add("modal-open");
            return false;
          }
        } else {
          if (window.cartFor == 'gift_card') {
            if (collections.indexOf('giftcard') == -1) {
              cartPreventModal.querySelector("[data-cart-message]").innerHTML = "Gift cards must be purchased separately. Please empty your cart then add the desired gift card and check-out.";
              cartPreventModal.removeAttribute("hidden");
              document.body.classList.add("modal-open");
              return false;
            }
          } else {
            if (collections.indexOf('pantry') > -1 || collections.indexOf('giftcard') > -1) {
              cartPreventModal.querySelector("[data-cart-message]").innerHTML = "This cart can process FireRoad Meal items only. If you want to add a Pantry item, please select the same item from the FireRoad Meals collection on this page and it will ship with the rest of your meals. <br /><br /><strong>Refresh your browser after emptying your cart.</strong>";
              cartPreventModal.removeAttribute("hidden");
              document.body.classList.add("modal-open");
              return false;
            }
          }
        }
        return true;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      getProductCollections() {
        return JSON.parse(this.querySelector("#product-collections").innerHTML);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
